require('./core');
import 'bootstrap4';
require('./grayscale');

import 'bootstrap4/scss/bootstrap.scss';
import '../css/grayscale.css';
import '../css/grayscale-band.css';
